"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = MadLibCards;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _lodash = _interopRequireDefault(require("lodash"));

var _classnames = _interopRequireDefault(require("classnames"));

var _formik = require("formik");

var _cardCheckbox = _interopRequireDefault(require("./card-checkbox"));

var _cardTextInput = _interopRequireDefault(require("./card-text-input"));

require("./mad-lib-cards.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
 * A form screen for MadLib. This is the default export.
 * @param {Array} segmentationCards Array of objects representing options for segments.
 */
function MadLibCards(_ref) {
  var inDialog = _ref.inDialog,
      segmentationCards = _ref.segmentationCards;

  var options = _lodash["default"].map(segmentationCards, function (_ref2) {
    var image = _ref2.image,
        label = _ref2.title;
    return (
      /*#__PURE__*/
      // by setting the name to `segment.label`, it sets the name as a value on the segment object
      // in the formik form state.
      _react["default"].createElement(_cardCheckbox["default"], {
        key: label,
        image: image,
        label: label,
        name: "segment.".concat(_lodash["default"].kebabCase(label))
      })
    );
  });

  return /*#__PURE__*/_react["default"].createElement("span", {
    key: "segmentation",
    className: (0, _classnames["default"])('MadLibCards inputField', {
      inDialog: inDialog
    })
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "errorMessage"
  }, /*#__PURE__*/_react["default"].createElement(_formik.ErrorMessage, {
    name: "email"
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "card-checkbox-grid"
  }, options, /*#__PURE__*/_react["default"].createElement(_cardTextInput["default"], {
    placeholder: "Make a suggestion..."
  })));
}

MadLibCards.propTypes = {
  inDialog: _propTypes["default"].bool,
  segmentationCards: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    image: _propTypes["default"].shape({}),
    // contentful media object
    title: _propTypes["default"].string
  }))
};
MadLibCards.defaultProps = {
  inDialog: false,
  segmentationCards: []
};